/* globals blinder */
import chroma from "chroma-js";

export const TYPICAL = "typical";

export function colorBlindCheck(colors, isSecondaryColors = false) {
    const types = [TYPICAL, "deuteranopia", "protanopia", "tritanopia"];
    let invalidTypes = [];
    let errors = [];
    for (let i = 0; i < types.length; i++) {
        let checkTypeColors = checkType(colors, types[i], isSecondaryColors);
        if (!checkTypeColors.passed) {
            invalidTypes.push(types[i]);
            errors = errors.concat(checkTypeColors.errors);
        }
    }
    return { invalidTypes, errors }
}

export function colorBlindSim(color, type) {
    if (type === TYPICAL) return color;
    return blinder[type](chroma(color).hex());
}

function checkType(colors, type, isSecondaryColors) {
    let notok = 0;
    let ratioThreshold = 5;
    let smallestPerceivableDistance = 9;
    let k = colors.length;
    if (!k) {
        return {
            passed: true,
            errors: []
        }
    }
    // compute distances between colors
    let errors = [];
    for (let a = 0; a < k; a++) {
        for (let b = a + 1; b < k; b++) {
            // don't perform colorblind test between secondary colors that were derived from the same base color
            // we assume that these are already the same hue and typically only vary in lightness
            if(isSecondaryColors && colors[a].baseColorIndex === colors[b].baseColorIndex) {
                continue;
            }

            let colorA = isSecondaryColors ? colors[a].secondaryColor : chroma(colors[a]);
            let colorB = isSecondaryColors ? colors[b].secondaryColor : chroma(colors[b]);
            let distanceNorm = difference(colorA, colorB);
            // if (distanceNorm < smallestPerceivableDistance) continue;

            let distanceSim = undefined;
            let aSim = undefined;
            let bSim = undefined;
            if (type === TYPICAL) {
                aSim = colorA;
                bSim = colorB;
                distanceSim = distanceNorm;
            } else {
                aSim = blinder[type](colorA.hex());
                bSim = blinder[type](colorB.hex());
                distanceSim = difference(aSim, bSim);
            }

            // if normal distance is small, we are OK with simulated distance being small too
            // and, if simulated distance is worse than minimum distance, then not OK
            let isNotOk =
                distanceNorm / distanceSim > ratioThreshold &&
                distanceSim < smallestPerceivableDistance;

            // if simulated distance is smaller than typical smallest perceivable distance, then not OK
            // let isNotOk = distanceSim < smallestPerceivableDistance;
            if (isNotOk) {
                // console.log(type, colors[a],colors[b],aSim+'',bSim+'', distanceNorm, distanceSim, distanceNorm/distanceSim);
                errors.push({
                    type, a: colorA, b: colorB, aSim: chroma(aSim), bSim: chroma(bSim),
                    distanceNorm, distanceSim,
                    ratio: distanceNorm/distanceSim
                })
            }

            // count combinations that are problematic
            if (isNotOk) notok++;
        }
    }

    return {
        passed: notok === 0,
        errors
    }
}

function difference(colorA, colorB) {
    return (
        0.5 * (chroma.deltaE(colorA, colorB) + chroma.deltaE(colorB, colorA))
    );
}
